import GainFedPay from "./GainFedPay";

export default GainFedPay